import { useQuery } from "react-query";
import { API_KEY_GET_PROGRAM } from "../utils";
import { getProgram } from "../api";

export const useGetProgram = (params) => {
  return useQuery([API_KEY_GET_PROGRAM, params], () => getProgram(params));
};
